import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useAddSectionsMutation,
    useUpdateSectionsMutation,
    useListAbouContentQuery,
} from "../../../../Services/AboutAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Editor } from "@tinymce/tinymce-react";

function AddStock() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        is_brand_bar_active: 1,
        section_one_text: "",
        section_one_image: null,
        is_section_one_active: 1,
        section_two_text: "",
        section_two_image: null,
        is_section_two_active: 1,
        section_three_text: "",
        section_three_image_one: null,
        section_three_image_two: null,
        is_section_three_active: 1,
        icon_text_one: "",
        icon_text_description_one: "",

        icon_text_two: "",
        icon_text_description_two: "",

        icon_text_three: "",
        icon_text_description_three: "",

        icon_text_four: "",
        icon_text_description_four: "",

        section_one_heading: "",
        section_two_heading: "",
        section_three_heading: "",
    });

    const [updateStock, { isLoading: updateLoading }] =
        useUpdateSectionsMutation();
    const [addStock, { isLoading: addLoading }] = useAddSectionsMutation();
    const {
        data: contentDetail,
        isLoading: loadingContent,
        error,
        refetch: refetchcontentDetail,
    } = useListAbouContentQuery();

    console.log("contentDetail", contentDetail);
    console.log(
        "icon_text_description_one",
        contentDetail?.data?.[0]?.section_one_heading
    );
    useEffect(() => {
        refetchcontentDetail();
    }, [refetchcontentDetail]);

    useEffect(() => {
        if (contentDetail?.data?.length > 0) {
            const existingData = contentDetail.data[0];
            setFormData((prev) => ({
                ...prev,
                is_brand_bar_active: existingData.is_brand_bar_active || 0,
                section_one_text: existingData.section_one_text || "",
                is_section_one_active: existingData.is_section_one_active || 0,
                section_two_text: existingData.section_two_text || "",
                is_section_two_active: existingData.is_section_two_active || 0,
                section_three_text: existingData.section_three_text || "",
                is_section_three_active: existingData.is_section_three_active || 0,
                section_one_heading: existingData.section_one_heading || "",
                section_two_heading: existingData.section_two_heading || "",
                section_three_heading: existingData.section_three_heading || "",
                icon_text_one: existingData.icon_text_one || "",
                icon_text_description_one: existingData.icon_text_description_one || "",

                icon_text_two: existingData.icon_text_two || "",
                icon_text_description_two: existingData.icon_text_description_two || "",

                icon_text_three: existingData.icon_text_three || "",
                icon_text_description_three:
                    existingData.icon_text_description_three || "",

                icon_text_four: existingData.icon_text_four || "",
                icon_text_description_four:
                    existingData.icon_text_description_four || "",
            }));
        }
    }, [contentDetail]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "radio"
                        ? Number(value) // Ensure number for radio
                        : files
                            ? files[0]
                            : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value !== null && value !== "") {
                    formDataToSend.append(key, value);
                }
            });

            if (contentDetail?.data?.length > 0) {
                const id = contentDetail?.data?.[0]?.id;
                await updateStock({ formData: formDataToSend, id }).unwrap();
                alert("Section updated successfully!");
            } else {
                await addStock({ formData: formDataToSend }).unwrap();
                alert("Section added successfully!");
            }

            refetchcontentDetail();
            navigate("/about-section-add");
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Something went wrong");
        }
    };
    const iconNumbers = ["one", "two", "three", "four"];

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>About</h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>
                    {/* SECTION ONE */}
                    <fieldset className="mb-4 border p-3">
                        <legend className="relative flex items-center space-x-2">
                            <div className="d-flex">
                                <div>
                                    <b>Section 1 </b>
                                </div>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">This section contains a title, description, and image. The image is aligned to the right, while the title and description are on the left. If you select "Active," the section will be shown. If you do not want to display this section, check "Inactive."</div>
                                </div>

                            </div>
                        </legend>

                        <div className="mb-3">
                            <div>
                                <label className="me-3">
                                    <input
                                        type="radio"
                                        name="is_section_one_active"
                                        value="1"
                                        checked={formData.is_section_one_active === 1}
                                        onChange={handleChange}
                                    />{" "}
                                    Show
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="is_section_one_active"
                                        value="0"
                                        checked={formData.is_section_one_active === 0}
                                        onChange={handleChange}
                                    />{" "}
                                    Hide
                                </label>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">Show/hide the section</div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Title</label>
                            <input
                                type="text"
                                className="form-control"
                                name="section_one_heading"
                                value={formData.section_one_heading}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Description</label>
                            {/* <textarea
                                className="form-control"
                                name="section_one_text"
                                rows={4}
                                value={formData.section_one_text}
                                onChange={handleChange}
                            /> */}
                            <Editor
                                apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                value={formData.section_one_text}
                                onEditorChange={(content) => 
                                    setFormData((prev) => ({ ...prev, section_one_text: content }))
                                  }
                                init={{
                                    height: 300,
                                    menubar: false,
                                    plugins: [
                                        "advlist",
                                        "autolink",
                                        "lists",
                                        "link",
                                        "preview",
                                        "searchreplace",
                                        "wordcount",
                                    ],
                                    toolbar:
                                        "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                    content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    paste_data_images: true,
                                    paste_as_text: false,
                                    paste_enable_default_filters: true,
                                    removed_menuitems: "paste",
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Image</label>
                            <input
                                type="file"
                                className="form-control"
                                name="section_one_image"
                                onChange={handleChange}
                            />
                        </div>
                    </fieldset>

                    {/* SECTION TWO */}
                    <fieldset className="mb-4 border p-3">
                        <legend className="relative flex items-center space-x-2">
                            <div className="d-flex">
                                <div>
                                    <b>Section 2 </b>
                                </div>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">This section contains a title, description, and image. The image is aligned to the left, while the title and description are on the right. If you select "Active," the section will be shown. If you do not want to display this section, check "Inactive."</div>
                                </div>

                            </div>
                        </legend>
                        <div>
                            <label className="me-3">
                                <input
                                    type="radio"
                                    name="is_section_two_active"
                                    value="1"
                                    checked={formData.is_section_two_active === 1}
                                    onChange={handleChange}
                                />{" "}
                                Show
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="is_section_two_active"
                                    value="0"
                                    checked={formData.is_section_two_active === 0}
                                    onChange={handleChange}
                                />{" "}
                                Hide
                            </label>
                            <div className="tooltip-container">
                                <FontAwesomeIcon
                                    icon={faCircleInfo}
                                    className="text-warning mx-2"
                                    style={{ cursor: "pointer" }}
                                />
                                <div className="tooltip">Show/Hide the section</div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Title</label>
                            <input
                                type="text"
                                className="form-control"
                                name="section_two_heading"
                                value={formData.section_two_heading}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Descriptoion</label>
                            {/* <textarea
                                className="form-control"
                                rows={4}
                                name="section_two_text"
                                value={formData.section_two_text}
                                onChange={handleChange}
                            /> */}
                            <Editor
                                apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                value={formData.section_two_text}
                                onEditorChange={(content) => 
                                    setFormData((prev) => ({ ...prev, section_two_text: content }))
                                  }
                                init={{
                                    height: 300,
                                    menubar: false,
                                    plugins: [
                                        "advlist",
                                        "autolink",
                                        "lists",
                                        "link",
                                        "preview",
                                        "searchreplace",
                                        "wordcount",
                                    ],
                                    toolbar:
                                        "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                    content_style:
                                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                    paste_data_images: true,
                                    paste_as_text: false,
                                    paste_enable_default_filters: true,
                                    removed_menuitems: "paste",
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label"> Image</label>
                            <input
                                type="file"
                                className="form-control"
                                name="section_two_image"
                                onChange={handleChange}
                            />
                        </div>


                    </fieldset>

                    {/* ICONS SECTION */}
                    <fieldset className="mb-4 border p-3">
                        <legend className="relative flex items-center space-x-2">
                            <div className="d-flex">
                                <div>
                                    <b>Section 3 </b>
                                </div>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">This section contains an icon, title, and description. It highlights our product features.</div>
                                </div>

                            </div>


                        </legend>


                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            {iconNumbers.map((num, index) => (
                                <div key={num} className="border p-4 rounded-md shadow-sm">
                                    <h4 className="text-lg font-semibold mb-2">{`Icon ${index + 1}`}</h4>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12 col-md-6">
                                            <label className="form-label">Title</label>
                                            <input
                                                type="text"
                                                className="form-control mb-3"
                                                name={`icon_text_${num}`}
                                                value={formData[`icon_text_${num}`]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6 col-sm-12 col-md-6">
                                            <label className="form-label">Description</label>
                                            <textarea
                                                className="form-control"
                                                name={`icon_text_description_${num}`}
                                                value={formData[`icon_text_description_${num}`]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </fieldset>

                    {/* SECTION THREE */}
                    <fieldset className="mb-4 border p-3">
                        <legend className="relative flex items-center space-x-2">
                            <div className="d-flex">
                                <div>
                                    <b>Section 4 </b>
                                </div>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">This section showcases our stunning collection of the year and includes two images of our featured collection products.</div>
                                </div>
                            </div>
                        </legend>
                        <div className="mb-3">
                            <div>
                                <label className="me-3">
                                    <input
                                        type="radio"
                                        name="is_section_three_active"
                                        value="1"
                                        checked={formData.is_section_three_active === 1}
                                        onChange={handleChange}
                                    />{" "}
                                    Show
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="is_section_three_active"
                                        value="0"
                                        checked={formData.is_section_three_active === 0}
                                        onChange={handleChange}
                                    />{" "}
                                    Hide
                                </label>
                                <div className="tooltip-container">
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="text-warning mx-2"
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div className="tooltip">Show/Hide the section</div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Title</label>
                            <input
                                type="text"
                                className="form-control"
                                name="section_three_heading"
                                value={formData.section_three_heading}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Sub Title</label>
                            <textarea
                                className="form-control"
                                name="section_three_text"
                                value={formData.section_three_text}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Image 1</label>
                            <input
                                type="file"
                                className="form-control"
                                name="section_three_image_one"
                                onChange={handleChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Image 2</label>
                            <input
                                type="file"
                                className="form-control"
                                name="section_three_image_two"
                                onChange={handleChange}
                            />
                        </div>


                    </fieldset>



                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={addLoading || updateLoading}
                    >
                        {addLoading || updateLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddStock;
